import { fetchy, FetchyError } from '@bridebook/web/lib/fetchy';
import { useMutation } from '@tanstack/react-query';
import { toggleSnackbar } from '@bridebook/web/lib/bbcommon/actions';
import { mapEmailApiError } from '@bridebook/web/lib/rsvp/utils/map-email-api-error';
import { useDispatch } from '@bridebook/web/lib/utils';
import { useTranslation } from 'next-i18next';
import { ISendTestMessageBody } from '@bridebook/web/pages/api/guest-comms/send-test-message';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';

export const useSendTestMessage = () => {
  const { locale, prefix } = useMarket();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async ({
      message,
      subject,
      displayPasswordInEmail,
      shareWeddingWebsiteLink,
      includeGuestsNames,
    }: ISendTestMessageBody['campaign']) => {
      try {
        await fetchy().authenticated.post('/api/guest-comms/send-test-message', null, {
          campaign: {
            subject,
            message,
            displayPasswordInEmail,
            shareWeddingWebsiteLink,
            includeGuestsNames,
          },
          market: {
            locale,
            prefix,
          },
        });
      } catch (error) {
        if (error instanceof FetchyError) {
          if (typeof error.body === 'object' && 'error' in error.body) {
            dispatch(toggleSnackbar('alert', mapEmailApiError(error.body.error, t)));
          }

          return;
        }
      }
    },
  });

  return { createEmailCampaign: mutateAsync, isLoading };
};
